export default __webpack_public_path__ + "static/media/microphone.92cd369e.svg";